import AnalyticsData from "../../model/AnalyticsData";
import AnalyticsTitle from "../AnalyticsTitle";
import { tt } from "../../../../utils/i18n/i18n";
import PieGraph from "../graphs/PieGraph";
import React, { useMemo } from "react";
import TitleAndTwoColumns from "../layout/TitleAndTwoColumns";
import getDefaultTitleForCTA from "../../../../utils/helpers/getDefaultTitleForCTA";
import { TokenHistoryLabel } from "kadow-jetpack-model/src";
import { isAcquisitionCTA } from "../../../../utils/helpers/isAcquisitionCTA";

interface Props {
  data?: AnalyticsData;
}

export default function (props: Props) {
  const totalActions = useMemo(() => {
    let res = 0;
    props.data?.distributionOfCTAs.forEach((d) => (res += d.count));
    return res;
  }, [props.data?.distributionOfCTAs]);

  const marketingCTAs = useMemo(() => {
    return props.data?.distributionOfCTAs?.filter(
      (d) => !isAcquisitionCTA(d._id as TokenHistoryLabel)
    );
  }, [props.data]);

  const nMarketingCTAs = useMemo(() => {
    let res = 0;
    marketingCTAs?.forEach((m) => {
      res += m.count;
    });
    return res;
  }, [marketingCTAs]);

  const businessCTAs = useMemo(() => {
    return props.data?.distributionOfCTAs?.filter((d) =>
      isAcquisitionCTA(d._id as TokenHistoryLabel)
    );
  }, [props.data]);

  const nBusinessCTAs = useMemo(() => {
    let res = 0;
    businessCTAs?.forEach((m) => {
      res += m.count;
    });
    return res;
  }, [businessCTAs]);

  if (!totalActions) {
    return null;
  }

  return (
    <TitleAndTwoColumns
      title={
        <AnalyticsTitle
          title={tt("analytics_total_actions_title", {
            totalActions
          })}
        />
      }
      left={
        <PieGraph
          title={tt("analytics_marketing_ctas", { count: nMarketingCTAs })}
          distribution={marketingCTAs}
          getDisplayNameForLabel={getDefaultTitleForCTA}
          suffix={tt("analytics_actions_suffix")}
        />
      }
      right={
        !!nBusinessCTAs ? (
          <PieGraph
            title={tt("analytics_business_ctas", {
              count: nBusinessCTAs
            })}
            distribution={businessCTAs}
            getDisplayNameForLabel={getDefaultTitleForCTA}
            suffix={tt("analytics_actions_suffix")}
          />
        ) : null
      }
    />
  );
}
